(function() {
    'use strict';

    angular
        .module('liverunApp')
        .controller('PromoCodeController', PromoCodeController);

    PromoCodeController.$inject = ['PromoCode'];

    function PromoCodeController(PromoCode) {

        var vm = this;

        vm.promoCodes = [];

        loadAll();

        function loadAll() {
            PromoCode.query(function(result) {
                vm.promoCodes = result;
                vm.searchQuery = null;
            });
        }
    }
})();
